import React, { useEffect, useState } from 'react';
import AccountDetailHeader from '../../components/accountDetailHeader';
import { getAccount } from '../../../../../../services/settings/accounting';
import PageLoader from '../../../../../../component/PageLoader';
import AccountBasicDetailsCard from '../../components/accountBasicDetailsCard';
import AccountDetailsCard from '../../components/accountDetailsCard';
import RecentTransaction from '../../components/recentTransaction';
import DeactivateAccountReasonModal from '../../components/deactivateAccountReasonModal';
import ActivateAccountModal from '../../components/activateAccountModal';
import CreateAccountsModal from '../../components/createAccountsModal';

export default function AccountsDetails({
	setIsOpenAccountsModal,
	setAccountId,
	accountId,
	setType,
	setLoader,
	loader,
	setIsOpenActivateAccountModal,
	setIsOpenDeactivateAccountModal,
	isOpenDeactivateAccountModal,
	isOpenActivateAccountModal,
	handleActivateAccount,
	showMessage,
}) {
	const [accountDetails, setAccountDetails] = useState({});
	const [isOpenAccount, setIsOpenAccount] = useState(false);

	const getAccountDetails = async () => {
		try {
			setLoader(true);
			const data = await getAccount(accountId);
			setAccountDetails(data);
		} catch (e) {
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		if (accountId) {
			getAccountDetails();
		}
	}, [accountId]);

	return loader ? (
		<PageLoader />
	) : (
		accountDetails && (
			<div>
				<div
					className="background-color"
					style={{ height: 'calc(100vh - 60px' }}
				>
					<AccountDetailHeader
						setIsOpenAccount={setIsOpenAccount}
						setIsOpenActivateAccountModal={setIsOpenActivateAccountModal}
						setIsOpenDeactivateAccountModal={setIsOpenDeactivateAccountModal}
						setAccountId={setAccountId}
						setType={setType}
						status={accountDetails?.status}
						accountName={accountDetails?.account_name}
					/>
					<AccountBasicDetailsCard accountDetails={accountDetails} />
					<AccountDetailsCard accountDetails={accountDetails} />
					<RecentTransaction
						row={
							accountDetails.recent_transactions && accountDetails.recent_transactions.length > 0
								? accountDetails.recent_transactions
								: []
						}
					/>
				</div>
				{isOpenAccount && (
					<CreateAccountsModal
						showMessage={showMessage}
						setSelectedId={setAccountId}
						selectedId={accountId}
						isOpenModal={isOpenAccount}
						setIsOpenModal={setIsOpenAccount}
						getList={getAccountDetails}
					/>
				)}
				{isOpenDeactivateAccountModal && (
					<DeactivateAccountReasonModal
						isOpenModal={isOpenDeactivateAccountModal}
						setIsOpenModal={setIsOpenDeactivateAccountModal}
						accountId={accountId}
						getAccountDetails={getAccountDetails}
					/>
				)}
				{isOpenActivateAccountModal && (
					<ActivateAccountModal
						accountId={accountId}
						isOpenModal={isOpenActivateAccountModal}
						setIsOpenModal={setIsOpenActivateAccountModal}
						handleActivateAccount={handleActivateAccount}
						getAccountDetails={getAccountDetails}
					/>
				)}
			</div>
		)
	);
}
